import React from 'react';
import {Edit} from 'react-admin';
import EmployeeForm from "./form";

export const EmployeeEdit = ({permissions, ...props}) => {
    return <Edit
        mutationMode='pessimistic'
        transform={employee => ({
            ...employee,
            hourlyRates: {
                "BASE": employee?.baseHourlyRate,
                "WINDOW": employee?.windowHourlyRate,
                "LAUNDRY": employee?.laundryHourlyRate,
                "COMMISSION": employee?.commissionHourlyRate,
                "BASE_DURING_COMMISSION_DAY": employee?.baseDuringCommissionDayHourlyRate,
            }
        })}
        {...props}
    >
        <EmployeeForm permissions={permissions} redirect='/employees'/>
    </Edit>
};

export default EmployeeEdit;